import * as amplitude from '@amplitude/analytics-browser'

const amplitudeConfig = {
  defaultTracking: true,
}

/* set up amplitude tracking.   */
export const setAmplitude = () => {
  if (window.location.hostname === 'localhost') return

  // some paths should not init amplitude because it will create an anonymnous user
  // example path: api/email_subscriptions/5c583375-577f-494c-8e94-e835ba9ebbd1/edit
  if (window.location.pathname.includes('/api/email_subscriptions')) {
    return
  }

  let key = 'e2ef560f39b9fd34d6a88c6408a34322'

  if (!window.location.host.includes('app.userevidence.com')) {
    key = 'b8604295517b15149875e298dca883bc'
  }
  amplitude.init(key, amplitudeConfig)
}

/* Track a user event in Amplitude.  This function should be called to track events in Pendo. */
// Note: please don't call this function directly.  use `trackEvent` from `@lib/tracking.ts`
export const amplitudeTrack = (eventName, properties) => {
  amplitude.track(eventName, properties)
}
